import React from 'react';
import KwPanel from '../../../common/KwPanel';
import FormDate from '../../../common/FormDate';
import FormTextArea from '../../../common/FormTextArea';
import announcementHelp from '../../../../constants/help/announcementHelp';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

export interface AnnouncementFormProps {
  announcement: { message?: string; announcementDate?: string; expiryDate?: string; [key: string]: unknown } | null;
  register: any;
  errors: any;
  control?: any;
}

const AnnouncementForm = ({ announcement, register, errors }: AnnouncementFormProps) => {
  const { t } = useTranslation();
  const language = i18next.language;
  const helpAnnouncementDate = (announcementHelp.ANNOUNCEMENT_DATE as Record<string, React.ReactNode>)[language];
  const helpExpiryDate = (announcementHelp.EXPIRY_DATE as Record<string, React.ReactNode>)[language];
  return announcement ? (
    <KwPanel className="mb-4 pb-1">
      <FormTextArea
        register={register}
        required={true}
        error={errors.message}
        errorMessage={t('Required')}
        name="message"
        label={t('Message')}
        defaultValue={announcement.message || ''}
        autoFocus={true}
      />
      <FormDate
        register={register}
        required={true}
        error={errors.message}
        errorMessage={t('Required')}
        name="announcementDate"
        defaultValue={announcement.announcementDate || ''}
        label={t('Announcement date')}
        helpContent={helpAnnouncementDate}
      />
      <FormDate
        register={register}
        required={true}
        error={errors.message}
        errorMessage={t('Required')}
        name="expiryDate"
        defaultValue={announcement.expiryDate || ''}
        label={t('Expiry date')}
        helpContent={helpExpiryDate}
      />
    </KwPanel>
  ) : (
    ''
  );
};

export default AnnouncementForm;
